// 日语
export default {
    login: {
        t01: '言語',
        t02: 'Netflix',
        t03: 'ユーザー名を入力してください',
        t04: 'パスワードを入力してください',
        t05: 'ログイン',
        t06: '登録する',
        t07: '電話番号を入力してください',
        t08: 'パスワードの確認',
        t09: '招待コードを入力してください',
        t10: 'アカウント登録',
        t11: 'パスワードの確認',
        t13: '映画への愛は、気づかないうちに豊かな財産を築くことにつながるかもしれません。',
        t14: 'ログイン成功',
        t15: 'パスワードが一致しません',
        t16: '登録成功',
        t17: 'ネットワークエラー',
        t18: 'リクエストタイムアウト、接続を確認してください'
    },
    cover_info: {
        t01: '稼ぎ始める',
        t02: 'コインチャージ',
        t03: 'コイン引き出し',
        t04: '証明書'
    },
    cont: {
        t01: '言語を選択してください',
        t02: '全て',
        t03: '未処理',
        t04: '完了',
        t05: '凍結中',
        t06: '残高',
        t07: '未完了',
        t08: '合計注文額',
        t09: '手数料',
        t10: '取得した手数料',
        t11: '注文数',
        t12: '利用可能な残高',
        t13: '注文を開始する',
        t14: '口座資金',
        t15: '注文を送信する',
        t16: '全ての注文を送信する',
        t17: '注文取得時間',
        t18: '注文番号',
        t19: '注文合計額',
        t21: '作品',
        t22: '俳優',
        t23: '作品コメント',
        t24: 'キャンセル',
        t25: '評価を選択してください',
        t26: '注文の送信が完了しました',
        t27: '注文を獲得しました',
        t28: '注文取得成功',
        t29: '注文取得に失敗しました。再度お試しください'
    }
    ,
    user: {
        t1: '紹介コード',
        t2: '残高',
        t3: '利用可能な残高',
        t4: '総利益',
        t5: '出金',
        t6: '入金履歴',
        t7: '出金履歴',
        t8: 'アカウント詳細情報',
        t9: 'メッセージ',
        t10: '銀行カードの接続',
        t11: 'パスワード変更',
        t12: '出金パスワード変更',
        t13: '友達を招待する',
        t14: '言語選択',
        t15: 'ログアウト',
        t16: '出金',
        t17: '出金額',
        t18: 'アカウント名',
        t19: '電話番号',
        t20: '出金額',
        t21: '出金',
        t22: '出금する量を入力してください',
        t23: '仮想通貨のパスワードを入力してください',
        t24: '総入金額',
        t25: 'システムメッセージ',
        t26: '銀行カード詳細情報',
        t27: '銀行リスト',
        t28: '銀行名',
        t29: '昵称',
        t30: '銀行カード番号',
        t31: '電話番号',
        t32: '変更内容を確認する',
        t33: '接続した銀行カードのアカウント番号とIFSC番号を入力してください。同時に、名前と電話番号を正確に入力する必要があります。そうでない場合は、入金額は届きません。',
        t34: '以前のパスワード',
        t35: '新しいパスワード',
        t36: 'パスワード確認',
        t37: '続行',
        t38: 'パスワードを記憶してください。パスワードを忘れた場合は、カスタマーサービスに連絡してください。',
        t39: '招待リンクのコピー',
        t40: '友達を招待して利益を得ましょう',
        t41: '入金する',
        t42: '確認',
        t43: 'キャンセル',
        t44: 'ログアウトしますか？',
        t45: '入金額',
        t46: '正常に入金されました',
        t47: '検証完了',
        t48: '検証待ち中',
        t49: '総出금額',
        t50: '先に出金パスワードを設定してください',
        t51: '以前のパスワードを入力してください',
        t52: '新しいパスワードを入力してください',
        t53: 'パスワード確認を入力してください',
        t54: '入力した2つのパスワードが一致していません',
        t55: 'コピーされました',
        t56: '出金額は30未満にできません',
        t57: '正常に送信され、リダイレクトされました',
        t58: 'レビューに失敗しました',
        t59: 'プロフィール写真を設定する',
        t60: '今すぐ設定',
        t61: '設定が成功しました',
        t62: 'ウォレットの承認後にログインしてお金を引き出す必要があります',
        t63: '銀行口座への出金',
        t64: 'USDTへの出金 (比率 1:0.013)',
        t65: '口座番号',
        t66: 'ご希望のバンキングカードを紐付けるには、バンクアカウント番号とIFSCコードを入力してください。また、フルネームと携帯電話番号も正確に入力してください。正しい情報を入力することで、滑らかな決済が可能になります.',
        t67: 'まず銀行カードをリンクしてください',
        t68: 'ユーザーのチャージ',
        t69: 'ユーザーの注文受け付け',
        t70: '下位のコミッション',
        t71: 'ユーザーの出金',
        t72: 'Yebaoに転送',
        t73: 'Yebaoから転送',
        t74: 'Yebaoの利益',
        t75: '注文コミッション',
        t76: '残高が30未満、取引を続けることができません。カスタマーサポートにお問い合わせください',
        t77: '銀行名を入力してください',
        t78: '銀行口座番号を入力してください',
        t80: 'フルネームを入力してください',
        t81: '電話番号を入力してください',
        t82: '出金額を入力してください',
        t83: 'コピー',
        t84: 'デイリートップ100: グローバル',
        t85: '聞く',
        t86: "メールアドレス",
        t87: "メールアドレスを入力してください",
        "t88": "銀行コード",
        "t89": "銀行コードを入力してください",
        t90: '銀行振込',
        t91: '1. 出金には手数料はかかりません',
        t92: '2. 出金後10〜15分以内に正常に反映されます。営業時間外の出金は、次の営業時間内に反映されます。'
    },
    movie: {
        t01: '人気の映画とテレビ番組',
        t02: '資金パスワード',
        t03: '注文差額',
        t04: 'オンチェーンアドレス管理',
        t05: '入力してください',
        t06: '正しいオンチェーンアドレスと対応するネットワーク（例：ERC20/TRC20/BTC）を入力してください。誤って入力すると、支払い/送金が届かない、または資産が失われる可能性があります。',
        t07: 'オンチェーンアドレスへ出金',
        t08: '追加してください',
        t09: 'オンチェーンアドレスを追加してください',
    },
    langType: '日语'
}
